import React, { Component } from 'react'
import styled from 'styled-components'

class PrivacyAgreementTDJa extends Component {
  state = {
    content: `引言
    
    照护同道（以下简称“我们”）非常重视您的个人信息，并让您对个人信息拥有控制权，我们会使用强大的加密技术来保护您的隐私，同时制定严格的政策来管理所有数据。当您访问照护同道时，或使用我们提供的服务前，您需要同意本政策中关于我们如何收集、使用、储存和分享您的相关信息的规定。如果您不同意本隐私政策中的任何内容，请立即停止使用或访问我们的产品和服务，其中一切商业行为与任何医院无任何关系。
    
    更新日期：2021年08月16日
    公司信息
    公司名称：天津九安医疗电子股份有限公司
    注册地址：天津市南开区雅安道金平路3号
    联系电话：022-87611660
    天津九安医疗电子股份有限公司深知个人信息对您的重要性，并会尽全力保护您的个人信息安全。在您使用照护同道APP时，我们恪守以下原则，保护您的个人信息：权责一致、目的明确、选择同意、最少够用、确保安全、主体参与、公开透明。同时，我们承诺，我们将按业界成熟的安全标准，采取相应的安全保护措施来保护您的个人信息。
    请您在使用我们的产品或服务前，请您仔细阅读本隐私政策的全部条款，以便您了解照护同道使用您个人信息的目的、范围、方式等。一旦您开始使用照护同道产品或服务，即表示您以充分理解并同意本政策。如果您为儿童，则请您在法定监护人陪同下审阅本隐私政策，经法定监护人审阅并同意后，您方可使用照护同道并向天津九安医疗电子股份有限公司提供个人信息。如果您或者监护人不同意本隐私政策任何内容，您应立即停止使用照护同道的产品或服务。当您使用照护同道提供的任一服务时，即表示您已同意我们按照本隐私政策来收集、使用、存储和保护您的相关信息。
    本隐私权政策旨在协助您了解我们会收集哪些信息、为什么收集这些信息，以及您如何更新、管理、导出和删除自己的信息。若您对本政策有任何问题，请联系：help@ihealthlabs.com.cn。
    
    术语
    Cookie：Cookie 是包含字符串的小文件，会在您访问网站时发送到您的计算机上。当您再次访问网站时，Cookie 使该网站可以识别您的浏览器。Cookie 还能存储用户使用偏好及其他信息。您可以重置您的浏览器拒绝所有的 Cookie，或者在发送 Cookie 时提示。但如果没有 Cookie，某些网站功能或服务可能无法正常工作。
    应用数据缓存：应用数据缓存是指设备上的一种数据存储机制。使用它有很多好处，例如，可让网络应用在未连接互联网的情况下运行，以及可通过提高内容加载速度来改善相关应用的性能。
    个人信息：用户向我们提供的、可用于识别用户的个人身份的信息，例如姓名、电子邮件地址、电话号码、银行卡号、身份证号码、住址、通讯记录等信息，或我们可以正当地通过链接找到此类信息的其他数据。
    IP地址：每台连接到互联网的计算机都指定了唯一的编号，称为互联网协议 (IP) 地址。由于这些编号通常都是根据国家/地区的区域指定的，因此 IP 地址通常可用于识别计算机连接至互联网时所在的国家/地区。
    
    一. 我们如何搜集和使用您的信息？
    1. 我们如何搜集您的信息？
    我们提供服务时，可能会收集、储存和使用下列信息：
    1.1 您提供的信息
    1.1.1 您在注册账户或使用我们的服务时，向我们提供相关个人信息，例如您的姓名、电话号码等信息。如果您想充分使用我们提供的各种分享功能，可能还需要创建公开显示的个人资料，其中可能会包含您的姓名和照片。
    1.1.2 您通过我们的服务向其他方提供的共享信息，以及您使用我们的服务时上传、提交、存储、发送或接收的信息。
    1.2 您在使用服务过程中，我们获取的信息
    我们会收集您使用的服务以及使用方式的信息，如您可以查看患者的各项健康信息，或何时查看了我们的视频和文章。此类信息包括：
    1.2.1 设备信息：我们会收集设备专用的信息，例如您的设备型号、设备品牌、CPU型号、设备制造商、设备所在地区、设备使用的语言、设备所用系统、系统版本号、设备IMEI、MAC地址、BSSID（无线接入点标识）和SSID（无线网络名称）等信息。其中，BSSID 与 SSID 用于识别您所处的无线网络环境，以便于保障服务正常运行、进行安全风控及改善网络连接体验。
    1.2.2 设备中的视频、图片等
    为了给您提供全方位的管理患者服务体验，经过您的授权，我们的服务器会提取您设备中的图片、视频等，并通过上传服务器，用于匹配与该视频、图片、软件相对应的显示功能。
    1.2.3 产品或服务使用过程中，需要无线网络的使用权限
    您在使用照护同道产品或服务过程中，我们需要开启您的无线网络权限以便于数据和信息的传输、存储和更新。
    
    2.我们可能将上述收集的信息用作以下用途
    2.1 向您提供服务；
    2.2 在我们提供服务时，用于身份验证、客户服务、安全防范、诈骗监测、存档和备份用途，确保我们向您提供的产品和服务的安全性；
    2.3 帮助我们设计新服务，改善我们现有服务；
    2.4 使我们更加了解您如何接入和使用我们的服务，从而针对性地回应您的个性化需求，例如语言设定、位置设定、个性化的帮助服务和指示，或对您和其他用户作出其他方面的回应
    2.5 执行软件验证、升级服务；
    2.6 其他有利于用户和照护同道运营者利益且不违反任何强制性法律法规的情况。
    2.7 让您参与有关我们产品和服务的调查
    
    3. 我们承诺
    3.1 我们不会根据敏感类别（例如种族、宗教、性取向或健康状况）向您展示个性化内容；
    3.2 在任何时候、任何情况下都不会向任何第三方出售您的个人信息，我们只会在法律允许的范围内使用根据本协议获得的信息。我们会制定严格的政策保护您的个人信息，除非事先获得您的授权或本声明另有规定之外，不会将您的这些信息对外公开或向第三方提供。
    
    4.与第三方公司合作
    4.1 为保证服务质量，我们可能会由关联公司或其他可信合作单位向您提供您所要求的服务或您可能感兴趣的内容。您同意我们向关联公司或合作单位分享该产品、服务所必须的个人信息。我们会要求关联公司及合作单位按照我们的说明、隐私政策以及任何其他适当的保密和安全措施来保证您的个人信息安全。除此之外，我们不会向任何第三方提供或分享您的信息。
    5.我们不会将您的个人信息转移或披露给任何非关联的第三方，除非：
    5.1在共享、转让、公开或披露个人信息时，获得您明确同意或您的授权后；
    5.2与国家安全、国防安全直接相关的；
    5.3在法律、法律程序、诉讼或政府部门强制性要求的情况下，我们可能会公开或披露您的个人信息；
    5.4与刑事侦查、起诉、审判和判决执行等直接相关的；
    5.5出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人授权同意的；
    5.6个人信息主体自行向社会公众公开的个人信息；
    5.7在完成合并、分立、收购或资产转让，我们可能会公开或披露您的个人信息；
    5.8与个人信息控制者履行法律法规规定的义务相关的；
    5.9从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道；
    5.10在法律法规和政策允许的范围内，为提升用户体验和提供个性化的推广服务；
    5.11以学术研究或公共利益为目的；
    5.12我们认为必要且不违反法律强制性规定的其他情形。
    
    6.隐私声明
    除非经过您的同意，否则我们不会向任何人提供您的敏感个人信息。
    
    二. 如何更新、变更、导出、删除您的信息
    1. 您在使用我们的产品和服务时，会被要求提供您真实的个人信息，您应当对您所提供信息的真实性、合法性、有效性及完整性负责，并及时更新和维护您的个人信息，以保证信息的真实、合法和有效。您可以随时管理您的个人信息，例如您的个人账户注册信息。
    2. 您可以自行从照护同道账号中删除您的内容或个人信息，或要求我们删除或修改信息，例如您想要删除个人帐户，可以发送邮件到help@ihealthlabs.com.cn与我们联络并提出您的要求。
    3. 在有些情况下，我们会出于法律目的或合法业务的需要将数据保留有限的一段时间。我们会尽力确保照护同道的服务能够保护信息免遭意外或恶意删除。因此，如果您删除了某些内容，我们可能会过一段时间才会从我们现用的和备用的系统中删除其副本。
    4. 您可以随时备份个人帐户名下的内容或将其用于非照护同道服务，您可以发邮件到help@ihealthlabs.com.cn与我们联络并提出您的要求。
    
    三. 我们如何保护您的个人信息
    所有照护同道产品都内置了强大的安全功能，并且我们制定了严格的信息管理政策，配备专业的技术团队，采取了一系列合理的预防措施，以保护您的个人信息不会遭受未经授权的浏览、披露、滥用、变更、破坏以及损失，其中包括：
    （1）使用加密技术来确保您的数据在传输过程中保持私密性；
    （2）提供多种安全功能来协助您保护自己的帐号安全；
    （3）审查我们在收集、存储和处理信息方面的做法（包括实体安全措施），以防未经授权的人员访问我们的系统；
    （4）所有因提供服务而必须接触个人信息的照护同道 App员工、承包商和代理商等，都需要遵守合同中规定的严格保密义务，否则可将被处分或被解约。
    
    四. 我们如何处理未成年人提供的个人信息
    我们非常重视未成年人信息的保护。我们只会在法律允许的范围内，或依当地法律取得监护人的同意，或是为了保护未成年人而使用或披露有关未成年人的个人数据。“未成年人”的定义应考虑适用的法律以及各国家和地区的文化惯例。
    
    五. 您分享的信息
    1. 我们会提供社交网络服务，您在使用这一类型服务时，您所上传或发布的信息（包括您公开的个人信息、您的通讯录、好友圈）、您对他人上传或发布的信息作出的回应，以及与这些信息有关的日志信息等，只要您不删除这些信息，它们会一直留存在公共领域，并被使用我们服务的其他用户分享、浏览。即使您删除这些信息，有关信息仍可能由其他用户或不受我们控制的非关联第三方独立地缓存、复制或储存，或由其他用户或第三方在公共领域保存。
    2. 请您谨慎考虑通过我们的服务上传、发布和交流的信息内容。在一些情况下，您可通过我们某些服务的隐私设定来控制有权浏览您共享信息的用户范围。您可以自行删除您上传、发布或分享的信息，如要求我们为您删除您的相关信息，请发送邮件到help@ihealthlabs.com.cn与我们联络并提出您的要求。
   
    六. 数据传输
    1. 我们使用的是中国大陆境内的服务器，因此，我们处理您的信息时严格遵守相应的法律法规，并严格按照法规保护您的数据。另外，我们还会遵守某些与数据传输有关的法律框架。
    2. 收到正式的书面投诉后，我们会与投诉方联系。我们会与相应的监管机构（包括当地的数据保护机构）合作，以解决任何与传输您的数据有关且无法由我们和您直接解决的投诉。
    
    七. 第三方服务提供商
    为方便您的访问并丰富您的体验，可能会有第三方提供的产品或服务。您可以选择是否访问这类内容或链接，或是否使用该第三方的产品或服务。但我们对于第三方提供的产品或服务没有控制权。我们无法控制第三方掌握的您的任何个人信息。您在使用第三方产品或服务过程中的信息保护问题，不适用于本政策的管理。本政策也不适用于您自行选择提供给第三方的任何信息。请您查看该第三方的隐私保护政策。我们会以高度的保密义务对待您的信息，除非获得您的明确同意，我们不会与本公司以外的任何公司、组织和个人分享您的个人信息，但经过处理无法识别特定个人且不能复原的除外，目前我们会在以下情形中，向您征求对共享您的个人信息的授权同意：
    （1）com.xiaomi.mipush(小米;小米推送)SDK、com.xiaomi.pushSDK：由小米科技有限责任公司提供技术支持，小米消息推送SDK收集您的外部存储状态、网络类型、设备制造商、设备制造国家、IMEI
    ANDROID_ID、IDFA、OpenUDID、IP 地址及推送状态，用于在小米、小米子品牌及小米合作商设备上接收消息推送，具体请见《小米帐号隐私政策》（https://static.account.xiaomi.com/html/privacy/account/zh_CN.html）；

    （2）com.huawei.hms(华为;华为推送) SDK：由华为软件技术有限公司提供技术支持，华为消息推送SDK收集您的外部存储状态，网络类型，设备制造商，设备制造国家，IMEI，ANDROID_ID，IDFA，OpenUDID，IP 地址及推送状态，用于在华为、华为子品牌及华为合作商设备上接收消息推送，具体请见《关于华为帐号与隐私的声明》（https://id1.cloud.huawei.com/AMW/v2/portal/agreements/accPrivacyStatement/index.html?lang=zh-cn&pageName=accPrivacyStatement&version=china&reqClientType=89&clientID=6099200&loginChannel=89000000）；

    （3）阿里云存储SDK：由阿里云计算有限公司提供技术支持，阿里云存储SDK收集您的网络类型、设备制造商、设备制造国家、IMEI及ANDROID_ID，用于在产品中信息和数据的存储和读取，具体请见《法律声明及隐私权政策》（https://terms.aliyun.com/legal-agreement/terms/suit_bu1_ali_cloud/suit_bu1_ali_cloud201710161525_98396.html）
    
    八.本政策的更新
    我们可能会不定期修改、更新本隐私政策，有关隐私政策的更新，我们会在照护同道中以通知公告等形式发布，您可以访问照护同道查询最新版本的隐私政策。对于重大变更，我们会向您发出郑重通知（包括对于某些服务，我们会通过电子邮件发送通知，说明对隐私政策进行的更改）。
    
    九. 适用范围
    1. 我们的隐私政策适用于由照护同道提供的患者信息管理服务，视频内容管理服务，个人信息管理服务，视频收益管理服务等，包括照护同道及www.ihealthlabs.com.cn上提供的服务，但是不包括附有独立隐私政策的服务（如第三方提供的产品和服务）。
`,
  }
  render() {
    return (
      <RootView>
        <TextContent
          dangerouslySetInnerHTML={{ __html: this.state.content }}
        ></TextContent>
      </RootView>
    )
  }
}

export default PrivacyAgreementTDJa

const RootView = styled.div`
  background-color: white;
  flex-direction: column;
  width: 100%;
  height: 100%;
`
const TextContent = styled.div`
  padding: 10px;
  white-space: pre-line;
`



// WEBPACK FOOTER //
// ./src/modules/activity/components/privacyAgreementTdJa.js